import React from "react";

import _ from "lodash";
import AllergyInfo from "components/attributes/panels/nutritionpanel/components/read-only/allergy-info";
import AttributeGroupData from "../../../contexts/attributes/attribute-group";
import RootField from "./components/root-field";
import { AttributeGroupItem } from "./components/attribute-group-item";

import { getDefaultValueByType } from "../../attributes/lib/attribute-data";
import { findField } from "../../attributes/compare-table/field-builder";
import { attributeUUID } from "shared/attribute-uuid";
import { useAttributeGroups } from "shared/hooks/api/use-attribute-groups";

import "./attribute-group-fields.scss";

const AttributeGroup = (props) => {
    const groupUUID = props.attribute.uuid;
    const defaultValue = props.defaultValue && props.defaultValue[groupUUID] ? props.defaultValue[groupUUID] : {};

    const hasValue = props.defaultValue && !_.isEmpty(props.defaultValue);

    const additionalInfo = props.attribute && props.attribute.additionalInfo ? props.attribute.additionalInfo : {};
    const parentGroup = additionalInfo.parentGroupInfo ? additionalInfo.parentGroupInfo.parentGroupName : "";

    const { data: groups } = useAttributeGroups(parentGroup ? [parentGroup] : []);

    if (groupUUID === attributeUUID.allergyInfo && props.readOnly) {
        const data = {
            contains: props.defaultValue[attributeUUID.allergyContains],
            mayContain: props.defaultValue[attributeUUID.allergyMayContain],
            doesNotContain: props.defaultValue[attributeUUID.allergyDoesNotContain],
        };

        return (
            <AllergyInfo
                isAttribute
                data={data}
            />
        );
    }

    const fields = groups.map((attr) => {
        const subGroup = attr.additionalInfo && attr.additionalInfo.parentGroupInfo ? attr.additionalInfo.parentGroupInfo.parentGroupName : null;

        if (subGroup) {
            const groupDefaultValue = defaultValue && defaultValue[attr.uuid] ? defaultValue[attr.uuid] : [];

            return (
                <AttributeGroupItem
                    key={`AG_${attr.uuid}`}
                    attribute={attr}
                    parentAttribute={props.attribute}
                    defaultValue={groupDefaultValue}
                    readOnly={props.readOnly}
                    updateOnChange={props.updateOnChange}
                    hasValue={hasValue}
                    disabled={props.disabled}
                    wipKey={props.wipKey}
                />
            );
        } else {
            const Field = findField(attr.componentType);
            const fieldDefaultValue =
                defaultValue && defaultValue[groupUUID] && defaultValue[groupUUID][attr.uuid]
                    ? defaultValue[groupUUID][attr.uuid]
                    : getDefaultValueByType(attr.componentType);

            return (
                <div key={`AIF_${attr.uuid}`}>
                    <label>{attr.name}</label>
                    <RootField
                        Field={Field}
                        attribute={attr}
                        parentAttribute={props.attribute}
                        attributeList={groups}
                        defaultValue={fieldDefaultValue}
                        isGroup={true}
                        readOnly={props.readOnly}
                        disabled={props.disabled}
                        updateOnChange={props.updateOnChange}
                    />
                </div>
            );
        }
    });

    return <div>{fields}</div>;
};

const AttributeGroupFields = (props) => {
    const uuid = props.attribute.uuid;

    return (
        <AttributeGroupData defaultValue={props.defaultValue}>
            <AttributeGroup
                {...props}
                uuid={uuid}
                readOnly={props.readOnly}
                disabled={props.disabled}
            />
        </AttributeGroupData>
    );
};

export default AttributeGroupFields;
